import { makeStyles } from '@material-ui/styles';
import { MDSIcon } from '@marqvision/mds-v2';
import { useSlider } from '../@hooks/useSlider';

const useStyles = makeStyles(() => ({
  wrapper: {
    position: 'absolute',
    top: '50%',
    left: '0',
    padding: '12px',
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    transform: 'translateY(-50%)',
  },
  button: {
    padding: '0',
    margin: '0',
    backgroundColor: 'transparent',
    border: 'none',
    borderRadius: '50%',
    opacity: '0',
    transition: '0.3s',

    '& svg': {
      filter: 'drop-shadow(0px 1px 8px rgba(0, 0, 0, 0.12)) drop-shadow(0px 1px 2px rgba(0, 0, 0, 0.04))',
    },

    ['&:not([disabled])']: {
      opacity: '0.7',
      cursor: 'pointer',
      '&:hover': {
        opacity: '1',
      },
    },
  },
}));

type Props = ReturnType<typeof useSlider>['arrowProps'];

export const Arrow = (props: Props) => {
  const { isNextDisabled, isPrevDisabled, onNext, onPrev } = props;
  const classes = useStyles();

  return (
    <div className={classes.wrapper}>
      <button className={classes.button} disabled={isPrevDisabled} onClick={onPrev}>
        <MDSIcon.ArrowLeft variant="fill" size={36} color="color/content/inverse/default/normal" />
      </button>
      <button className={classes.button} disabled={isNextDisabled} onClick={onNext}>
        <MDSIcon.ArrowRight variant="fill" size={36} color="color/content/inverse/default/normal" />
      </button>
    </div>
  );
};
